
define('modules/application/wizard/steps/zoneStep/complexZoneStep/energyManagementZoneStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../complexZoneStep",
  "./energyManagementZoneStep/zoneDetailView",
  "./energyManagementZoneStep/zoneModel",
  "./energyManagementZoneStep/zonesMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  complexZoneStep,
  ZoneDetailView,
  ZoneModel,
  ZonesMenuView) {

  var Views        = _.extend({}, complexZoneStep.Views);

  Views.Content    = Views.Content.extend({
    addConstructors : function() {
      complexZoneStep.Views.Content.prototype.addConstructors.apply(this);
      this.ZoneDetailView = ZoneDetailView;
      this.ZonesMenuView  = ZonesMenuView;
    }
  });

  var energyManagementZoneStep = _.extend({}, complexZoneStep, {
    objClass      : "automationZoneStep",
    Model         : complexZoneStep.Model.extend({

      addConstructors                     : function() {
        complexZoneStep.Model.prototype.addConstructors.apply(this);
        this.ZoneDetailView = ZoneDetailView;
        this.ZoneModel      = ZoneModel;
      },

      initialize                          : function() {
        complexZoneStep.Model.prototype.initialize.apply(this);
        this.get("stepEventAggregator").unbind("zoneStatusCheck:requested",  this.checkZonesStatus);
        this.get("stepEventAggregator").bind("zoneStatusCheck:requested",    this.checkZonesStatus, this);
      },

      checkZonesStatus                     : function() {
        if ( (this.collection.checkZonesStatus()) && (this.checkAdditionalZones()) )
          this.get("stepEventAggregator").trigger('collection:validated');
        else
          this.get("stepEventAggregator").trigger('collection:unvalidated');
      },

      checkAdditionalZones                : function() {
        var validCollection = true;
        for (var i=0;i<this.additionalZones.length;i++)
          if (this.additionalZones[i].role!=="separator" && !this.additionalZones[i].isValid())
          {
            validCollection = false;
            break;
          }
        return validCollection;
      },

      getZoneNumber                       : function(zoneName) {
        var zoneNumber = 0;

        switch(zoneName)
        {
          case "IDS_WAM8_25_3" :  zoneNumber = -6;
                                  break;
          case "IDS_W3_9010"   :  zoneNumber = -5;
                                  break;
          case "IDS_W3_9011"   :  zoneNumber = -4;
                                  break;
          case "IDS_W3_9013"   :  zoneNumber = -3;
                                  break;
          case "IDS_W3_9014"   :  zoneNumber = -2;
                                  break;
          case "IDS_WAM8_25_2" :  zoneNumber = -1;
                                  break;
        }

        return zoneNumber;
      },

      duplicateSelectedZone               : function() {
        var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;

        if (this.collection.length<maxZoneNumber) {
          var selectedModel = this.collection.filter(function(currentModel){
            return currentModel.get("selected");
          });

          //Creating base model
          var modelToAdd = new this.ZoneModel(
            _.extend(
              selectedModel[0].toJSON(),
              {number : this.collection.length+1}
            )
          );

          var k=2;
          var nameFound;
          while (!nameFound) {
            for (var i=0; i<this.collection.models.length; i++) {
              if (this.collection.models[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))==(modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")"))
                break;
              else if (i==this.collection.models.length-1)
                nameFound=true;
            }
            if (!nameFound)
              k++;
          }

          modelToAdd.set("name", modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")");

          //////////////////////////////////
          //Creating new this.amplifierAndLoudSpeakersModel
          //////////////////////////////////
          var amplifierAndLoudSpeakersModelToAdd    = new this.amplifierAndLoudSpeakers.Model(
            _.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("amplifierAndLoudSpeakersModel").attributes)
          );
          modelToAdd.set("amplifierAndLoudSpeakersModel", amplifierAndLoudSpeakersModelToAdd);

          //Adding new this.model to the collection
          this.addZone(modelToAdd);
          this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        }
        else {
          alert($.i18n._("IDS_W1_9090"));
        }
      },

      deliverModel                        : function() {
        var additionalZones   = this.additionalZones,
            regularZones      = this.collection.models,
            dataProvider      = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            secondaryProducts = [],
            models,
            collection,
            scenariosCommands,
            integrationDevices;
        var zonesItems, zoneToPush, modelToAnalyse;
        var i=0, j=0, l=0, m=0;
        var retrieveScenarioItems = function(iterableComponent){return (iterableComponent.specialVars) ? iterableComponent.specialVars.scenarios : false;};

        BticinoS4B.solution.energyManagement.zones = this;
        BticinoS4B.Instances.Models.ApplicationModel.set("zones", BticinoS4B.solution.energyManagement.zones);
        BticinoS4B.solution.energyManagement.additionalZones = additionalZones;
        BticinoS4B.Instances.Models.ApplicationModel.set("additionalZones", BticinoS4B.solution.energyManagement.additionalZones);

        zonesItems          = BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") : [];

        //Additional zones
        for (i=0; i<additionalZones.length; i++)
        {
          if (additionalZones[i].attributes)
          {
            zoneToPush = {
              name   : additionalZones[i].get("name"),
              number : additionalZones[i].get("number"),
              items: []
            };

            //Advanced commands
            if( additionalZones[i].get("name")==="IDS_W3_9010")
            {
              if (additionalZones[i].get("advancedCommandsModel"))
              {
                models = additionalZones[i].get("advancedCommandsModel").deliverModel();
                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }

              if (additionalZones[i].get("scenariosCommandsModel"))
              {
                models            = additionalZones[i].get("scenariosCommandsModel").deliverModel();
                scenariosCommands = models;

                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }
            }
            //Control
            else if( additionalZones[i].get("name")==="IDS_W3_9011" )
            {
              if (additionalZones[i].get("automationRemoteControlsModel"))
              {
                models = additionalZones[i].get("automationRemoteControlsModel").deliverModel();
                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }

              if (additionalZones[i].get("integrationDevicesModel"))
              {
                models             = additionalZones[i].get("integrationDevicesModel").deliverModel();
                integrationDevices = models;

                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);

                if (scenariosCommands && scenariosCommands.length>0)
                {
                  //If there's no scenarios items
                  if ((_.filter(integrationDevices, retrieveScenarioItems)).length===0)
                  {
                    //Retrieve an "actuator-like" object for scenarios
                    models = additionalZones[i].get("integrationDevicesModel").getScenariosObjs();
                    for(j=0; j<models.length; j++)
                      //dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
                      dataProvider.addItems("automaticItems",    models[j]);
                  }
                }
              }
            }
            //Controlled loads
            else if( additionalZones[i].get("name")==="IDS_W3_9013")
            {

              if (additionalZones[i].get("controlledLoadsModel"))
              {
                models = additionalZones[i].get("controlledLoadsModel").deliverModel();
                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }

              if (additionalZones[i].get("commandsModel"))
              {
                models = additionalZones[i].get("commandsModel").deliverModel();
                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }
            }
            //Consumption visualization
            else if (additionalZones[i].get("name")==="IDS_W3_9014")
            {
              //Gauges and interfaces
              if(additionalZones[i].get("gaugesAndInterfacesModel"))
              {
                models = additionalZones[i].get("gaugesAndInterfacesModel").deliverModel();
                for(j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }
            }
            //Traditional
            else if (additionalZones[i].get("name")==="IDS_WAM8_25_2")
            {
              //Traditional
              if(additionalZones[i].get("traditionalModel"))
              {
                modelToAnalyse = additionalZones[i].get("traditionalModel");
                if (modelToAnalyse)
                {
                  collection = modelToAnalyse.get("collection").models ? modelToAnalyse.get("collection").models : [];
                  for (j=0; j<collection.length; j++)
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : collection[j].get("partOfKit"),
                      productCode        : collection[j].get("productCode"),
                      productLabel       : collection[j].get("productLabel"),
                      packageClassLabel  : collection[j].get("packageClassLabel"),
                      packageClassId     : collection[j].get("packageClassId"),
                      quantity           : collection[j].get("value"),
                      price              : collection[j].get("price")
                    });

                    secondaryProducts = collection[j].get("secondaryProducts");
                    if (secondaryProducts)
                      for (l=0; l<secondaryProducts.length; l++) {
                        dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                          partOfKit          : collection[j].get("partOfKit"),
                          productCode        : secondaryProducts[l].productCode,
                          productLabel       : secondaryProducts[l].productLabel,
                          packageClassLabel  : secondaryProducts[l].packageClassLabel,
                          packageClassId     : secondaryProducts[l].packageClassId,
                          quantity           : modelToAnalyse.get("collection").models[j].get("value"),
                          price              : secondaryProducts[l].price
                        });
                      }
                  }
                }
              }
            }
            //Automation
            else if (additionalZones[i].get("name")==="IDS_WAM8_25_3")
            {
              if (additionalZones[i].get("lightPointsModel"))
              {
                models = additionalZones[i].get("lightPointsModel").deliverModel();
                for (j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }

              if (additionalZones[i].get("enginesModel"))
              {
                models = additionalZones[i].get("enginesModel").deliverModel();
                for (j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }

              if (additionalZones[i].get("commandPointsModel"))
              {
                models = additionalZones[i].get("commandPointsModel").deliverModel();
                for (j=0; j<models.length; j++)
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), models[j]);
              }
            }

            zonesItems.push(zoneToPush);
          }
        }

        var product;
        var retrieveProductCode   = function(item) {return item.productCode;};
        var checkNonZeroQuantity  = function(item) {return item.quantity>0;};
        var sumQuantities         = function(memo, item){return memo + item.quantity;};

        for (i=0; i<zonesItems.length; i++)
        {
          if (zonesItems[i].items instanceof Array)
          {
            zonesItems[i].items   = _.filter(zonesItems[i].items, checkNonZeroQuantity);

            /*Grouping products*/
            zonesItems[i].items   = _.groupBy(zonesItems[i].items, retrieveProductCode);

            /*Sum quantities*/
            for (product in zonesItems[i].items)
              zonesItems[i].items[product][0].totalQuantity = _.reduce(zonesItems[i].items[product], sumQuantities, 0.00);
          }
        }
        BticinoS4B.solution.energyManagement.zonesItems = zonesItems;
        BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", BticinoS4B.solution.energyManagement.zonesItems);
      },

      deliverCurrent                      : function() {
        //var collection = this.collection, collectionLength = collection.length;
        //var i=0;
//
        //for (i=0; i<collectionLength; i++)
        //  collection.models[i].deliverCurrent();
      },


      loadProject                         : function(model) {
/*        var number = 1;
        this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});

        //Load automation zone
        if(model.automation)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_WAM8_25_3", number : -6, isAdditional : true}, model.automation));
          number = -6;
        }

        //Load advanced commands zone
        if (model.advancedCommands)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_W3_9010",   number : -5, isAdditional : true}, model.advancedCommands));
          number = -5;
        }

        //Load control zone
        if (model.control)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_W3_9011",   number : -4, isAdditional : true}, model.control));
          number = -4;
        }

        //Load loadsControl zone
        if (model.loadsControl)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_W3_9013",   number : -3, isAdditional : true}, model.loadsControl));
          number = -3;
        }

        //Load consumptionVisualization zone
        if (model.consumptionVisualization)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_W3_9014",   number : -2, isAdditional : true}, model.consumptionVisualization));
          number = -2;
        }

        //Load traditional zone
        if (model.traditional)
        {
          this.loadAdditionalZone(_.extend({name : "IDS_W3_9014",   number : -1, isAdditional : true}, model.traditional));
          number = -1;
        }

        if (model.zones)
          for (var i=0; i<model.zones.length; i++)
          {
            this.loadZone(model.zones[i]);
          }

        this.get("stepEventAggregator").trigger("zone:loaded");
        this.get("stepEventAggregator").trigger("render:requested");
        window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", number);*/
      }

    }),
    Views         : Views
  });

  // Required, return the module for AMD compliance
  return energyManagementZoneStep;

});